export enum CartIoApplyMode {
    Insert = 'insert',
    Append = 'append',
    Replace = 'replace',
}